import { useLayoutEffect, useRef } from "react";

export const AutoText = ({ value, onChange, disabled, className = "", placeholder, testId, bold }) => {
  const ref = useRef(null);
  useLayoutEffect(() => { const el = ref.current; if (el) { el.style.height = "auto"; el.style.height = `${el.scrollHeight}px`; } }, [value]);
  return (
    <textarea ref={ref} rows={1} value={value} disabled={disabled} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testId}
      className={`w-full resize-none overflow-hidden rounded-md border border-transparent bg-transparent px-1 py-0.5 leading-relaxed outline-none transition-colors hover:border-slate-200 focus:border-violet-400 focus:bg-violet-50/40 disabled:hover:border-transparent ${bold ? "font-bold" : ""} ${value?.includes("[Perlu dilengkapkan]") ? "bg-amber-50" : ""} ${className}`} />
  );
};

export const IconBtn = ({ onClick, label, children, testId }) => (
  <button onClick={onClick} aria-label={label} title={label} data-testid={testId} className="grid h-7 w-7 shrink-0 place-items-center rounded-md text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700">{children}</button>
);
